const transformCardType = (card) => {
    const { integration_type } = card;
    card.integration_type =
        integration_type === 'salesforceusernamepasswordflow'
            ? 'salesforce'
            : integration_type;
    return card;
};
export function transformCustomCardIntegrationByIdResponse(response) {
    transformCardType(response.data);
    return response;
}
export function transformCustomCardIntegrationsResponse(response) {
    response.data.custom_cards.forEach(transformCardType);
    return response;
}
